import * as segment from 'rp-analytics';

export const trackSearchClick = () => {
    segment.track('Stallion Book Search');
};



// WEBPACK FOOTER //
// ./src/client/utils/trackHelper.js